import { computed } from 'vue';
import { flattenSavedViewPages, useAllSavedViewsQuery } from '@/composables/api/useSavedViewsApi';
import type { SavedViewAppearance } from '@/utils/savedViewAppearance';

/**
 * A saved view's icon and colour, looked up by id in the list of every view.
 *
 * Recent items and Cmd+K's search hits carry only a view's id and name. Looking
 * the rest up here, instead of storing it with them, means a view shows its new
 * icon everywhere the moment it changes. A view not in the list, such as one
 * deleted since, gets the default bookmark.
 */
export function useSavedViewAppearances() {
    const allViews = useAllSavedViewsQuery();
    const byId = computed(() => new Map(flattenSavedViewPages(allViews.data.value).map((view) => [view.id, view])));
    return (viewId: number): SavedViewAppearance | null => byId.value.get(viewId) ?? null;
}
